import { oneOf, bool, node, string } from 'prop-types';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export var FormLabelEffect;
(function (FormLabelEffect) {
    FormLabelEffect["none"] = "none";
    FormLabelEffect["float"] = "float";
    FormLabelEffect["scale"] = "scale";
})(FormLabelEffect || (FormLabelEffect = {}));
export const formLabelPropTypes = {
    as: oneOf(['label', 'legend', 'span']),
    children: node.isRequired,
    disabled: bool,
    effect: oneOf(Object.values(FormLabelEffect)),
    empty: bool,
    htmlFor: string,
    invalid: bool,
    required: bool,
    ...spacingPropTypes,
};
//# sourceMappingURL=FormLabel.types.js.map